// Blend mode for graph materials (Unreal-style): opaque | masked | translucent.
//
// Opacity masking is material-level and shader-agnostic (same in Blender and
// three.js): the graph's `opacity` output writes diffuseColor.a, and these
// render props decide what happens to that alpha — hard-discard (masked) or
// smooth blend (translucent). This mapping is kept dependency-free so it
// unit-tests without pulling in THREE; buildGraphMaterial applies the result
// plus `side`/depth. Standard pbr/toon/skin materials use the legacy
// `blendType` path in avatarMaterial.js instead.
//
//   opaque      → alpha ignored
//   masked      → discard where alpha < clip value (alphaTest)   [UE Masked / glTF MASK]
//   translucent → alpha blend (transparent)                      [UE Translucent / glTF BLEND]

export const GRAPH_BLEND_MODES = ['opaque', 'masked', 'translucent']

// Default clip value — matches Unreal's material default
// (OpacityMaskClipValue = 0.3333f, Material.cpp).
export const DEFAULT_CLIP = 0.3333

// Map an output-node `data` object ({ blendMode, clip }) to the THREE material
// render props. Returns { transparent, alphaTest }. Unknown modes → opaque.
// `clip` is the masked cutoff (Unreal Opacity Mask Clip Value / glTF alphaCutoff).
export function graphBlendMode(d = {}) {
  const mode = d.blendMode ?? 'opaque'
  if (mode === 'masked') {
    return { transparent: false, alphaTest: d.clip ?? DEFAULT_CLIP }
  }
  if (mode === 'translucent') {
    return { transparent: true, alphaTest: 0 }
  }
  return { transparent: false, alphaTest: 0 }
}
